import { render, staticRenderFns } from "./Monetize.vue?vue&type=template&id=4eb6ccd0&scoped=true&"
import script from "./Monetize.vue?vue&type=script&lang=js&"
export * from "./Monetize.vue?vue&type=script&lang=js&"
import style0 from "./Monetize.vue?vue&type=style&index=0&id=4eb6ccd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb6ccd0",
  null
  
)

export default component.exports